import React from "react"
import {graphql} from "gatsby"
import Seo from "../components/Seo"
import {Grid, Col, Video} from "../components/DesignSystem"
import ProjectHeader from "../components/ProjectHeader"
import ProjectContent from "../components/ProjectContent"
import ProjectFooter from "../components/ProjectFooter"
import * as Shortcodes from "../components/Shortcodes"

const shortcodes = {
  Grid, Col, Video, ...Shortcodes
}


const ProjectPostTemplate = ({ data, pageContext, location }) => {

  const post = data.mdx
  // const siteTitle = data.site.siteMetadata.title
  // const { previous, next } = pageContext
  return (
    // <Layout location={location} title={siteTitle}>
    <div>
      <Seo
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />
      {/* <nav>
      <Link to="/">← Au Duong Tuan</Link>
      <Link to="/about">About</Link> 
      </nav> */}
      <article itemScope itemType="http://schema.org/Article">
        
        <ProjectHeader post={post} location={location}></ProjectHeader>

        <ProjectContent post={post} shortcodes={shortcodes}></ProjectContent>
       
        <ProjectFooter {...pageContext}></ProjectFooter>
      </article>

     
    </div>
  )
}

export default ProjectPostTemplate

export const pageQuery = graphql`
  query ProjectPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        type
        date(formatString: "MMMM, YYYY")
        description
        role
        tools
        logo {
          publicURL
        }
        web {
          publicURL
        }
        cover {
          childImageSharp {
            gatsbyImageData(
              width: 800,
              placeholder: BLURRED
            )
          }
        }
        cover2 {
          childImageSharp {
            gatsbyImageData(
              width: 800,
              placeholder: BLURRED
            )
          }
        }
        background
        achievements
      }
    }
  }
`
